import React, { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Image } from "../../../AbstractElements";
import { smallSizescroll } from "../../../Constant";
import HeaderCard from "../../Common/HeaderCard";
import ScrollBar from "react-perfect-scrollbar";

const SmallSizeScroll = () => {
  return (
    <Fragment>
      <Col sm="6">
        <Card>
          <HeaderCard title={smallSizescroll} />
          <CardBody>
            <div className="scroll-bar-wrap">
              <ScrollBar className="scrollbar-margins large-margin scroll-demo p-0" style={{ height: 300, width: "100%" }}>
                <Image src={require("../../../assets/images/banner/3.jpg")} alt="" width={735} height={600} />
              </ScrollBar>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default SmallSizeScroll;
